import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { MobileAdvanceRequestDetail } from './Pages';

export const MobileAdvanceRequestDetailRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={MobileAdvanceRequestDetail} />
    </Fragment>
)